export default {


  getData(token) {
    return env.API.get('/user/data', token ? {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    } : undefined);
  },
  updateGeneralSettings(data) {
    return env.API.put('/user/general', data);
  },
  updateLocation(data) {
    return env.API.put('/user/location', data);
  },
  updatePassword(data) {
    return env.API.put('/user/password', data);
  },
  updateSystemSettings(data) {
    return env.API.put('/user/system', data);
  },
  getReferralLink() {
    return env.API.post('/user/generateReferralLink');
  },
  checkRefLink(data) {
    return env.API.post('/checkReferralLink',{ referral : data })
  },
  changeUserPlan(id) {
    return env.API.post('/user/changePlan', {planId : id});
  },
  getUserCounters() {
    return env.API.get('/user/currents');
  },
  getCompanyDashboard() {
    return env.API.get('/user/dashboard/company');
  },
  
  fillInfo(data) {
    return env.API.put('/user/info', data);
  },

  saveCurrency(code) {
    return env.API.post('/user/changeCurrency', {code: code});
  },

  getPaymentMethod(code) {
    return env.API.get('/user/pm');
  },

  setPaymentMethod(pm_id) {
    return env.API.put('/user/pm', {
      paymentMethodId: pm_id,
    });
  },
  saveUnit(data) {
    return env.API.post('/user/saveUnit', data);
  },
}
